import {
  commitAppointmentPlanningBatch,
  previewAppointmentPlanningBatch,
} from "../../../../../api/kehrblatt/planning"
import type { AppointmentPlanningOperations } from "../../../_shared/_logic/appointments-contract"

export const appointmentPlanningDomainOperations: AppointmentPlanningOperations = {
  loadPreview: previewAppointmentPlanningBatch,
  commit: async (payload) => ({
    response: await commitAppointmentPlanningBatch(payload),
    receipt: undefined,
  }),
}
